module.exports = __webpack_public_path__ + "static/media/64.79fd9a36.png";